const SWING_ROOT_TLD = "swingeducation.com";
const SWING_SUBS_HOST = `subs.${SWING_ROOT_TLD}`;
const SWING_SUPPORT_HOST = `support.${SWING_ROOT_TLD}`;
const SWING_REFER_HOST = `start.${SWING_ROOT_TLD}`;
// SWING SUBS NEW STACK
const SWING_SUBS_PROD_HOST = `swingsubs.${SWING_ROOT_TLD}`;
const SWING_SUBS_STAGING_HOST = `swingsubs.aws.${SWING_ROOT_TLD}`;
const SWING_SUBS_LOCAL_HOST = "localhost:3001";
const SWING_SUBS_IOS_APP_STORE_DESTINATION = "https://apps.apple.com/us/app/swing-subs/id6480072147";
const SWING_SUBS_ANDROID_APP_STORE_DESTINATION = "https://play.google.com/store/apps/details?id=com.swingeducation.swingsubs";
// SWING SCHOOLS NEW STACK
const SWING_SCHOOLS_PROD_HOST = `admins.${SWING_ROOT_TLD}`;
const SWING_SCHOOLS_STAGING_HOST = `admins.aws.${SWING_ROOT_TLD}`;
const SWING_SCHOOLS_LOCAL_HOST = "localhost:3000";
const SWING_SCHOOLS_IOS_APP_STORE_DESTINATION = "https://apps.apple.com/us/app/swing-schools/id6477969868";
const SWING_SCHOOLS_ANDROID_APP_STORE_DESTINATION = "https://play.google.com/store/apps/details?id=com.swingeducation.adminapp";
const generateSwingURL = ({ host, scheme = "https", path }) => {
    return `${scheme}://${host}${path}`;
};
export const generateSwingRootURL = (path = "") => generateSwingURL({ host: SWING_ROOT_TLD, path });
export const generateSwingSubsProdURL = (path = "") => generateSwingURL({ host: SWING_SUBS_PROD_HOST, path });
export const generateSwingSubsStagingURL = (path = "") => generateSwingURL({ host: SWING_SUBS_STAGING_HOST, path });
export const generateSwingSubsLocalURL = (path = "") => generateSwingURL({ host: SWING_SUBS_LOCAL_HOST, path, scheme: "http" });
export const generateSwingSubsAppleAppStoreURL = () => SWING_SUBS_IOS_APP_STORE_DESTINATION;
export const generateSwingSubsGooglePlayStoreURL = () => SWING_SUBS_ANDROID_APP_STORE_DESTINATION;
export const generateSwingSchoolsProdURL = (path = "") => generateSwingURL({ host: SWING_SCHOOLS_PROD_HOST, path });
export const generateSwingSchoolsStagingURL = (path = "") => generateSwingURL({ host: SWING_SCHOOLS_STAGING_HOST, path });
export const generateSwingSchoolsLocalURL = (path = "") => generateSwingURL({ host: SWING_SCHOOLS_LOCAL_HOST, path, scheme: "http" });
export const generateSwingSchoolsAppleAppStoreURL = () => SWING_SCHOOLS_IOS_APP_STORE_DESTINATION;
export const generateSwingSchoolsGooglePlayStoreURL = () => SWING_SCHOOLS_ANDROID_APP_STORE_DESTINATION;
export const generateSwingSubURL = (path = "") => generateSwingURL({ host: SWING_SUBS_HOST, path });
export const generateSwingSupportURL = (path = "") => generateSwingURL({ host: SWING_SUPPORT_HOST, path });
export const generateSwingReferURL = (path = "") => generateSwingURL({ host: SWING_REFER_HOST, path });
export const openHelpCenter = () => window.open(generateSwingSupportURL(), "_blank");
export const getRouteDetailsAsList = (router) => {
    return router?.routeInfo?.pathname?.substring(1)?.split("/");
};
export const getBaseURLFromRouter = (router) => {
    const routeDetailsList = getRouteDetailsAsList(router);
    return routeDetailsList?.[0] || "";
};
//# sourceMappingURL=url.js.map